import { Link } from "./AppLink";

const noticeCopy = {
  en: {
    title: "Assistance Request Procedures",
    greeting: "Dear Customers,",
    paragraphs: [
      "As part of Tarahum Charity Foundation’s ongoing efforts to enhance its services and expedite assistance procedures, we would like to inform you that assistance requests submitted up to the end of May that are still pending can be easily resubmitted through our updated system.",
      "You can also track the status of your requests through your personal account under the “Assistance Requests” section.",
    ],
    closing: "We apologize for any inconvenience and appreciate your understanding and cooperation.",
    action: "View Assistance Requests",
    signature: "Tarahum Charity Foundation",
  },
  ar: {
    title: "إشعار بشأن إعادة تقديم طلبات المساعدة",
    greeting: "متعاملينا الأعزاء،",
    paragraphs: [
      "في إطار جهود مؤسسة تراحم الخيرية لتطوير خدماتها وتسريع إجراءات المساعدة، نود إعلامكم بإمكانية إعادة تقديم طلبات المساعدة السابقة التي لا تزال قيد الانتظار حتى نهاية شهر مايو، بكل سهولة عبر النظام المحدّث.",
      "كما يمكنكم متابعة حالة طلباتكم من خلال ملفكم الشخصي عبر قسم «طلبات المساعدة».",
    ],
    closing: "نعتذر عن أي إزعاج، ونشكركم على تفهمكم وتعاونكم.",
    action: "عرض طلبات المساعدة",
    signature: "مؤسسة تراحم الخيرية",
  },
};

export default function AssistanceRequestNotice({ language = "en", dashboard = false, onViewRequests }) {
  const isArabic = language === "ar";
  const copy = noticeCopy[isArabic ? "ar" : "en"];

  const actionContent = (
    <>
      <span>{copy.action}</span>
      <i className={`fa-solid ${isArabic ? "fa-arrow-left" : "fa-arrow-right"}`} aria-hidden="true" />
    </>
  );

  return (
    <section
      className={`assistance-request-notice${dashboard ? " assistance-request-notice--dashboard" : ""}`}
      dir={isArabic ? "rtl" : "ltr"}
      aria-labelledby={dashboard ? "dashboard-assistance-notice-title" : "home-assistance-notice-title"}
    >
      <div className="assistance-request-notice__accent" aria-hidden="true" />
      <div className="assistance-request-notice__icon" aria-hidden="true">
        <i className="fa-solid fa-bullhorn" />
      </div>
      <div className="assistance-request-notice__content">
        <h2 id={dashboard ? "dashboard-assistance-notice-title" : "home-assistance-notice-title"}>{copy.title}</h2>
        <p className="assistance-request-notice__greeting">{copy.greeting}</p>
        {copy.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        <p className="assistance-request-notice__closing">{copy.closing}</p>
        <strong className="assistance-request-notice__signature">{copy.signature}</strong>
      </div>
      <div className="assistance-request-notice__action">
        {dashboard ? (
          <button type="button" data-target-tab="Aid-Requests" onClick={onViewRequests}>{actionContent}</button>
        ) : (
          <Link to="/beneficent-dashboard">{actionContent}</Link>
        )}
      </div>
    </section>
  );
}
